function personSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Person',
    familyName: 'Tendulkar',
    givenName: 'Sachin',
    worksFor: 'https://unacademy.com/',
    jobTitle: 'Cricketer',
    image:
      'https://icons.uacdn.net/commons/im/3c666837-2ecc-4df4-9b9b-24ab17b44dfa.jpeg?q=75&w=1000&fm=webp',
    gender: 'https://schema.org/Male',
    sameAs: [
      'https://twitter.com/sachin_rt',
      'https://www.facebook.com/SachinTendulkar',
      'https://www.youtube.com/channel/UCnzTvgqX77zZBJ5mji5bi7w',
      'https://www.instagram.com/sachintendulkar',
      'https://en.wikipedia.org/wiki/Sachin_Tendulkar'
    ]
  };
}

export default personSchema;
